import { organizedModelPriceMapping } from './constants';
import { findMatches } from './findMatches';

export function getPriceBodyMatch(
  numberOfTiles,
  rankedPriceRanges,
  rankedBodyTypes,
  modelBlackList,
) {
  // let topMatchForBodyType1;
  // let topMatchForBodyType2;
  // let selectedModelNames = [];

  // top body price matrix 1
  const group1 = [
    organizedModelPriceMapping[rankedBodyTypes[0]][rankedPriceRanges[0]],
    organizedModelPriceMapping[rankedBodyTypes[0]][rankedPriceRanges[1]],
    organizedModelPriceMapping[rankedBodyTypes[1]][rankedPriceRanges[0]],
    organizedModelPriceMapping[rankedBodyTypes[2]][rankedPriceRanges[0]],
  ];

  // top body price matrix 2
  const group2 = [
    organizedModelPriceMapping[rankedBodyTypes[0]][rankedPriceRanges[2]],
    organizedModelPriceMapping[rankedBodyTypes[1]][rankedPriceRanges[1]],
    organizedModelPriceMapping[rankedBodyTypes[1]][rankedPriceRanges[2]],
    organizedModelPriceMapping[rankedBodyTypes[2]][rankedPriceRanges[1]],
    organizedModelPriceMapping[rankedBodyTypes[2]][rankedPriceRanges[2]],
    organizedModelPriceMapping[rankedBodyTypes[3]][rankedPriceRanges[2]],
    organizedModelPriceMapping[rankedBodyTypes[3]][rankedPriceRanges[1]],
  ];

  // todo: make 3 & fallback roster
  const combinedGroups = [...group1, ...group2].filter((value) => value !== undefined);

  return findMatches(combinedGroups, numberOfTiles, modelBlackList);
}
